import React from 'react';

/**
 * Feb-2026: user asked us to strip the entire footer down to the copyright
 * strip + a nearly-invisible Google Site Verification link (so the site
 * stays verified without cluttering the bottom of the home page).
 */
const Footer = () => {
  return (
    <footer className="bg-white border-t border-[#e1ddd6] mt-16" data-testid="app-footer">
      <div className="max-w-7xl mx-auto px-8 py-4 text-center">
        <p className="text-[#8a8f99] text-xs">
          © 2026 The Vaad Otzar
          <span className="mx-2 text-[#e1ddd6]">·</span>
          <a
            href="/privacy"
            className="text-[#4b5563] hover:text-[#9a7b24] transition-colors text-xs"
            data-testid="footer-privacy-link"
          >
            Privacy
          </a>
          <span className="mx-2 text-[#e1ddd6]">·</span>
          <a
            href="/terms"
            className="text-[#4b5563] hover:text-[#9a7b24] transition-colors text-xs"
            data-testid="footer-terms-link"
          >
            Terms
          </a>
        </p>
        {/* Google Site Verification — kept out of visual flow so we stay
            verified without adding noise to the footer. */}
        <a
          href="/google9acf6f56b9d338af.html"
          className="sr-only focus:not-sr-only text-[10px] text-transparent hover:text-[#9a7b24]"
          data-testid="google-site-verification-link"
          rel="noopener"
          aria-hidden="true"
          tabIndex={-1}
        >
          .
        </a>
      </div>
    </footer>
  );
};

export default Footer;
